import { useContext } from "react";
import { CredibleLogoLight } from "../../assets/images";
import { useStepper } from "../LoanApplicationSteps/Stepper";
import { ProgressBar } from "../../components";
import { SDKContext } from "../../contexts";
import clsx from "clsx";
import { useDpConfig } from "../../contexts/dpConfig";

const LoanApplicationFlowHeader = () => {
  const { currentStep, steps } = useStepper();
  const { options } = useContext(SDKContext);
  const {
    state: { settings },
  } = useDpConfig();

  return (
    <>
      <div className="cx-flex cx-justify-center cx-items-center cx-w-full cx-border-b cx-border-stroke-primary">
        {!settings.hideHeader && (
          <div className="cx-flex cx-justify-between cx-items-center cx-w-full cx-max-w-[960px] cx-px-2 cx-py-4">
            <div className="cx-max-h-14 cx-min-h-[42px] cx-flex cx-justify-center cx-items-center">
              {!settings.hideLogo && (
                <img
                  src={options?.logoUrl || CredibleLogoLight}
                  className={clsx({
                    "cx-h-6": !options?.logoUrl,
                    "cx-h-14": options?.logoUrl,
                  })}
                  alt={"logo"}
                />
              )}
            </div>
          </div>
        )}
      </div>
      {!steps[currentStep[0]].hideProgress ? (
        <div className="cx-w-full cx-px-2">
          <ProgressBar steps={steps} currentStep={currentStep} />
        </div>
      ) : null}
    </>
  );
};

export default LoanApplicationFlowHeader;
